module.exports = new __parcel__URL__("loading_screen_prog_2.ce0e7660.png").toString();